<template lang="html">

  <section>

    <div>
      <iframe src="https://cruzroja.iformalia.es/Publico/Portal/OfertaFormacionListado.aspx?idc=&return=no&returnurl=%20%E2%80%8B" ></iframe>
    
    </div>
  </section>

</template>

<script lang="js">
export default {
  name: 'aviso-legal',
  props: [],
  mounted() {

  },
  data() {
    return {

    }
  },
  methods: {

  },
  computed: {

  }
}
</script>

<style scoped>
iframe {
  margin-top: 60px;
  width: 100vw;
  height: 100vh;
  border: 0;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/views/test.vue